/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
import { getPayloadObject, getTelemetryAttributes, ITelemetryContent, onTelemetryClick } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { ILinksData } from '../obrien-promo-banner.props.autogenerated';

export interface IPromoBannerLinks {
    links: ILinksData[];
    requestContext: Msdyn365.IRequestContext;
    telemetryContent: ITelemetryContent;
    onTextChange?(index: number): (event: Msdyn365.ContentEditableEvent) => void;
}

export const PromoBannerLinks: React.FC<IPromoBannerLinks> = ({ links, requestContext, onTextChange, telemetryContent }) => {
    const editableLinks = _mapEditableLinks(links, telemetryContent);
    return(
        <span className='ms-promo-banner__links'>
            {editableLinks && editableLinks.length ?
                <Msdyn365.Links
                    links= {editableLinks}
                    editProps={{onTextChange: onTextChange, requestContext: requestContext}}
                />
                : null
            }
    </span>
    );
};

const _mapEditableLinks = (linkdata: ILinksData[], telemetryContent: ITelemetryContent): Msdyn365.ILinksData[] | null => {
    if(!linkdata || linkdata.length === 0) {
        return null;
    }
    const editableLinks: Msdyn365.ILinksData[] = [];
    linkdata.forEach((link,index) => {
        // Construct telemetry attribute to render
        const payLoad = getPayloadObject('click', telemetryContent, '', '');
        const linkText = link.linkText ? link.linkText : '';
        payLoad.contentAction.etext = linkText;
        const attributes = getTelemetryAttributes(telemetryContent, payLoad);
        const editableLink: Msdyn365.ILinksData = {
            ariaLabel: link.ariaLabel,
            className: 'ms-promo-banner__link',
            linkText: link.linkText,
            linkUrl: link.linkUrl.destinationUrl,
            openInNewTab: link.openInNewTab,
            role: 'button',
            additionalProperties: attributes,
            onClick: onTelemetryClick(telemetryContent, payLoad, linkText)
        };
        editableLinks.push(editableLink);
    });

    return editableLinks;
};
